export enum CloudAssetStatus {
    Active = 1,
    Deprecated = 2
}

export const mapToCloudAssetStatus = (status: number): CloudAssetStatus => {
    if (!isCloudAssetStatus(status)) {
        throw new Error("Wrong asset status");
    }

    return status;
};

const isCloudAssetStatus = (status: number): status is CloudAssetStatus => {
    return Object.values(CloudAssetStatus).includes(status);
};
